import { FusionAuthClient } from '@fusionauth/typescript-client';
import { api_key, fusion_url } from 'utils/constant/index';
export const FusionAuthClientInstance = new FusionAuthClient(api_key, fusion_url);

// client.login({"loginId":"tester-dev@yopmail.com","password":"Test@123.."}).then((res)=>{
//     res.response.user.
// }).catch((err))
